import { GroupedTableColumn } from "../../common/components/functional/GroupedTable/GroupedTable";
import { ItemGroupLoadingState } from "../invoices/invoiceAPI";

// eezyAccepted:
// null -> ApplicantStatusGroupName.New
// (exists) -> ApplicantStatusGroupName.Processed
// true -> ApplicantStatus.Accepted
// false -> ApplicantStatus.Rejected

export enum ApplicantStatusGroupName {
  Search = "search", // Haku - tätä ei ole designissa, mutta TalentsStatus.tsx on myös käytetty tällaista
  Accepted = "accepted", // Eezy hyväksynyt
  Rejected = "rejected", // Eezy hylännyt
  New = "new", // Uudet
}

export enum ApplicantStatus {
  EezyAccepted = "eezyAccepted",
  EezyRejected = "eezyRejected",
}

export enum ApplicantStatusAction {
  Suitable = "suitable",
  NotSuitable = "notSuitable",
  SendRejectedMessage = "sendRejectedMessage",
}

export const APPLICANTS_STATUS_GROUPS_DEFAULT_VALUES = [
  {
    name: ApplicantStatusGroupName.Search,
    items: [],
    status: ItemGroupLoadingState.IDLE,
  },
  {
    name: ApplicantStatusGroupName.Accepted,
    items: [],
    status: ItemGroupLoadingState.IDLE,
  },
  {
    name: ApplicantStatusGroupName.New,
    items: [],
    status: ItemGroupLoadingState.IDLE,
  },
  {
    name: ApplicantStatusGroupName.Rejected,
    items: [],
    status: ItemGroupLoadingState.IDLE,
  },
];

export const JOB_AD_CAMPAIGNS = [
  {
    id: "Kesätyöt - Ravintolat ja kahvilat",
    name: "Kesätyöt - Ravintolat ja kahvilat",
  },
  {
    id: "Kesätyöt - Teollisuus",
    name: "Kesätyöt - Teollisuus",
  },
  {
    id: "Kesätyöt - Varasto ja kuljetus",
    name: "Kesätyöt - Varasto ja kuljetus",
  },
  {
    id: "Kesätyöt - Kauppa ja myynti",
    name: "Kesätyöt - Kauppa ja myynti",
  },
  {
    id: "Kesätyöt - Festarit ja tapahtumat",
    name: "Kesätyöt - Festarit ja tapahtumat",
  },
  {
    id: "Kesätyöt - Toimisto ja asiakaspalvelu",
    name: "Kesätyöt - Toimisto ja asiakaspalvelu",
  },
  {
    id: "Kesätyöt - Siivous ja vihertyöt",
    name: "Kesätyöt - Siivous ja vihertyöt",
  },
  {
    id: "Kesätyöt - Rakentaminen",
    name: "Kesätyöt - Rakentaminen",
  },
];

export const JOB_AD_COLUMNS: GroupedTableColumn[] = [
  {
    fieldName: "creationDate",
    displayName: "creationDate",
    width: "6%",
    headerSx: { minWidth: "5rem", maxWidth: "5rem" },
    sx: { minWidth: "5rem", maxWidth: "5rem" },
  },
  {
    fieldName: "orderTitle",
    displayName: "orderTitle",
    width: "10%",
    headerSx: { minWidth: "6rem", maxWidth: "6rem" },
    sx: { minWidth: "6rem", maxWidth: "6rem" },
  },
  {
    fieldName: "title",
    displayName: "adTitle",
    width: "14%",
    headerSx: { minWidth: "8rem", maxWidth: "8rem" },
    sx: { minWidth: "8rem", maxWidth: "8rem" },
  },
  {
    fieldName: "locationCity",
    displayName: "location",
    width: "6%",
    headerSx: { minWidth: "4rem", maxWidth: "4rem" },
    sx: { minWidth: "4rem", maxWidth: "4rem" },
  },
  {
    fieldName: "startDate",
    displayName: "startDate",
    width: "6%",
    headerSx: { minWidth: "5rem", maxWidth: "5rem" },
    sx: { minWidth: "5rem", maxWidth: "5rem" },
  },
  {
    fieldName: "endDate",
    displayName: "endDate",
    width: "6%",
    headerSx: { minWidth: "6rem", maxWidth: "6rem" },
    sx: { minWidth: "6rem", maxWidth: "6rem" },
  },
  {
    fieldName: "customer",
    displayName: "customer",
    width: "10%",
    headerSx: { minWidth: "6rem", maxWidth: "6rem" },
    sx: { minWidth: "6rem", maxWidth: "6rem" },
  },
  {
    fieldName: "employer",
    displayName: "employer",
    width: "8%",
    headerSx: { minWidth: "6rem", maxWidth: "6rem" },
    sx: { minWidth: "6rem", maxWidth: "6rem" },
  },
  {
    fieldName: "publishingSites",
    displayName: "publishingSites",
    width: "10%",
    headerSx: { minWidth: "7rem", maxWidth: "7rem" },
    sx: { minWidth: "7rem", maxWidth: "7rem" },
  },
  {
    fieldName: "contactPersonName",
    displayName: "contactPerson",
    width: "12%",
    headerSx: { minWidth: "7rem", maxWidth: "7rem" },
    sx: { minWidth: "7rem", maxWidth: "7rem" },
  },
  {
    fieldName: "state",
    displayName: "state",
    width: "8%",
    headerSx: { minWidth: "6rem", maxWidth: "6rem" },
    sx: { minWidth: "6rem", maxWidth: "6rem" },
    flairComponent: true,
  },
  {
    fieldName: "totalApplicants",
    displayName: "applicants",
    width: "4%",
    headerSx: { minWidth: "4rem", maxWidth: "4rem" },
    sx: { minWidth: "4rem", maxWidth: "4rem" },
  },
  {
    fieldName: "newApplicants",
    displayName: "newApplicants",
    width: "4%",
    headerSx: { minWidth: "4rem", maxWidth: "4rem" },
    sx: { minWidth: "4rem", maxWidth: "4rem" },
  },
];

export const APPLICANTS_STATUS_COLUMNS: GroupedTableColumn[] = [
  {
    fieldName: "applicant",
    displayName: "",
    width: "59%",
    disableTooltip: true,
    headerSx: {
      padding: "8px 0px",
    },
  },
  {
    fieldName: "link",
    displayName: "",
    width: "auto",
    disableTooltip: true,
    align: "right",
    sx: {
      paddingRight: "10px",
      whiteSpace: "nowrap",
      color: "text.secondary",
      maxWidth: 250,
      overflowWrap: "break-word",
      hyphens: "auto",
      overflow: "visible",
    },
    headerSx: {
      padding: "8px 0px",
    },
  },
  {
    fieldName: "appliedAt",
    displayName: "appliedAt",
    width: "auto",
    align: "center",
    sx: {
      padding: "8px 0px",
      width: "7%",
      maxWidth: "7%",
      color: "text.secondary",
      overflowWrap: "break-word",
      hyphens: "auto",
      overflow: "visible",
      borderLeft: "1px solid #000A441C",
    },
    headerSx: {
      width: "7%",
      maxWidth: "7%",
      color: "text.secondary",
      verticalAlign: "bottom",
      overflowWrap: "break-word",
      hyphens: "auto",
      overflow: "visible",
      borderLeft: "1px solid #000A441C",
      lineHeight: "15.4px",

      padding: "8px 0px",
    },
    isTimeline: false,
  },
  {
    fieldName: "eezyAccepted",
    displayName: "eezyAccepted",
    width: "auto",
    align: "center",
    sx: {
      padding: "8px 0px",
      width: "7%",
      maxWidth: "7%",
      color: "text.secondary",
      overflowWrap: "break-word",
      hyphens: "auto",
      overflow: "visible",
      borderLeft: "1px solid #000A441C",
    },
    headerSx: {
      width: "7%",
      maxWidth: "7%",
      color: "text.secondary",
      verticalAlign: "bottom",
      overflowWrap: "break-word",
      hyphens: "auto",
      overflow: "visible",
      borderLeft: "1px solid #000A441C",
      lineHeight: "15.4px",

      padding: "8px 0px",
    },
    isTimeline: false,
  },
  {
    fieldName: "eezyRejected",
    displayName: "eezyRejected",
    disableTooltip: true,
    width: "auto",
    align: "center",
    sx: {
      padding: "8px 0px",
      width: "7%",
      maxWidth: "7%",
      color: "text.secondary",
      overflowWrap: "break-word",
      hyphens: "auto",
      overflow: "visible",
      borderLeft: "1px solid #000A441C",
    },
    headerSx: {
      width: "7%",
      maxWidth: "7%",
      color: "text.secondary",
      verticalAlign: "bottom",
      overflowWrap: "break-word",
      hyphens: "auto",
      overflow: "visible",
      borderLeft: "1px solid #000A441C",
      lineHeight: "15.4px",

      padding: "8px 0px",
    },
    isTimeline: false,
  },
];
